module.exports = __webpack_public_path__ + "media/Loops Bass.80056787.wav";